module.exports = __webpack_public_path__ + "static/media/gndu_logo.69215096.png";